module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu",
    staticStyle: {
      "background": "url(static/images/backgroundcs.png) no-repeat bottom",
      "background-color": "#A7D7F5",
      "background-size": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "muenBoxs"
  }, [_c('div', {
    staticClass: "parents"
  }, [(_vm.allMenu.dormMg) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/studentRoomManger', '/wx/room/mg/checkPermission')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("学生住房管理")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.inRoomCollege) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/CheckInQuery', '/wx/inroom/query/checkCollegePermission')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("学院入住查询")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.inRoomDorm) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/BuildingQuery', '/wx/inroom/query/checkDormPermission')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("楼栋入住查询")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.inRoomZh) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/CompreHensivelyQuery', '/wx/inroom/query/checkZhPermission')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("综合入住查询")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.changeRoomApply) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/RoomChangeApplication', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("换房申请")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.changeRoomHqAudit) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/RoomChangeSH', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("换房审核")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.changeRoomWyAudit) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/RoomChangeQR', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("换房确认")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.sqTeacherAttend) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/DormitoryManagement', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("舍区老师管理")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topLogo"
  }, [_c('img', {
    staticClass: "leftLogo",
    attrs: {
      "src": "static/images/logoblack.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rightLogo",
    attrs: {
      "src": "static/images/wsbsdt.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d014a08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/indexMenu.vue
// module id = 840
// module chunks = 1